import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-40 text-gray-333 working-style-master-create-container" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "font-bold font-size-24 mb-4" }
const _hoisted_4 = { class: "font-size-16" }
const _hoisted_5 = { class: "midnight-content" }
const _hoisted_6 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_8 = { class: "w-2/5 mb-4" }
const _hoisted_9 = { class: "w-2/5 mb-4" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_12 = { class: "font-size-14" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "font-size-14 font-bold" }
const _hoisted_16 = { class: "font-size-14 mb-1" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "mt-3 ml-2" }
const _hoisted_19 = { class: "mb-4 w-2/5" }
const _hoisted_20 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_21 = { class: "font-size-14 mb-1" }
const _hoisted_22 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_23 = { class: "w-24 mb-4" }
const _hoisted_24 = { class: "mt-4 font-bold font-size-14 mb-1" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = { class: "mt-4 font-bold font-size-14 mb-1" }
const _hoisted_27 = { class: "flex flex-wrap" }
const _hoisted_28 = { class: "w-32 mr-3" }
const _hoisted_29 = { class: "w-24 mr-3" }
const _hoisted_30 = { class: "w-32 mr-3" }
const _hoisted_31 = { class: "w-24" }
const _hoisted_32 = { class: "mb-8 w-2/5" }
const _hoisted_33 = { class: "mt-4 font-bold font-size-14 mb-1" }
const _hoisted_34 = { class: "mb-8" }
const _hoisted_35 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_37 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "flex justify-end" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)
const _hoisted_41 = { class: "flex items-center justify-center font-size-16" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-right text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Input = _resolveComponent("Input")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_BreakSetting = _resolveComponent("BreakSetting")
  const _component_WorkingSchedule = _resolveComponent("WorkingSchedule")
  const _component_GoOutSetting = _resolveComponent("GoOutSetting")
  const _component_AutomaticBreak = _resolveComponent("AutomaticBreak")
  const _component_BeingLateTime = _resolveComponent("BeingLateTime")
  const _component_Button = _resolveComponent("Button")
  const _component_ConfirmRegisterWorkingStyleMaster = _resolveComponent("ConfirmRegisterWorkingStyleMaster")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.backToListWorkingStyleMaster }, null, 8, ["onClick"]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('workingStyleMaster')) + " : " + _toDisplayString(_ctx.isUpdateAction ? _ctx.t('edit') : _ctx.t('signUp')), 1),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('allAreRequiredFields')), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('basicSettings')), 1),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Input, {
            label: _ctx.t('workingStyleCode'),
            placeholder: _ctx.t('pleaseEnter'),
            modelValue: _ctx.workingStyleMasterParams.working_style_code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workingStyleMasterParams.working_style_code = $event)),
            required: "",
            validated: _ctx.validated,
            errors: _ctx.errors.working_style_code,
            "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.working_style_code = $event)),
            "error-server": _ctx.errorServer.working_style_code
          }, null, 8, ["label", "placeholder", "modelValue", "validated", "errors", "error-server"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Input, {
            label: _ctx.t('workingStyleName'),
            placeholder: _ctx.t('pleaseEnter'),
            modelValue: _ctx.workingStyleMasterParams.working_style_name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.workingStyleMasterParams.working_style_name = $event)),
            required: "",
            validated: _ctx.validated,
            errors: _ctx.errors.working_style_name,
            "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.working_style_name = $event)),
            "error-server": _ctx.errorServer.working_style_name
          }, null, 8, ["label", "placeholder", "modelValue", "validated", "errors", "error-server"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('businessDaySwitchTime')), 1),
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('theDayOfStamps')), 1),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Select, {
              class: "w-20 mr-2",
              placeholder: _ctx.t('choice'),
              "options-select": _ctx.dailyClosingTimeDayTypeOption,
              modelValue: _ctx.workingStyleMasterParams.daily_closing_time_day_type,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.workingStyleMasterParams.daily_closing_time_day_type = $event)),
              "item-text": "text"
            }, null, 8, ["placeholder", "options-select", "modelValue"]),
            _createVNode("div", null, [
              _createVNode(_component_InputTime, {
                width: "96px",
                modelValue: _ctx.workingStyleMasterParams.daily_closing_time,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.workingStyleMasterParams.daily_closing_time = $event)),
                validated: _ctx.validated,
                errors: _ctx.errors.daily_closing_time,
                "onUpdate:errors": _cache[7] || (_cache[7] = ($event: any) => (_ctx.errors.daily_closing_time = $event)),
                required: ""
              }, null, 8, ["modelValue", "validated", "errors"]),
              _createVNode(_component_ErrorMessage, {
                "error-server": _ctx.errorServer.daily_closing_time
              }, null, 8, ["error-server"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('oneDayConsecutiveWorkingHours')), 1),
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('afterThisTimeTheStampScreenSwitchesToWorkMode')), 1),
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_Input, {
              modelValue: _ctx.workingStyleMasterParams.maximum_working_hours_per_day,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.workingStyleMasterParams.maximum_working_hours_per_day = $event)),
              "error-server": _ctx.errorServer.maximum_working_hours_per_day,
              validated: _ctx.validated
            }, null, 8, ["modelValue", "error-server", "validated"]),
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('time2')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('distinguishingBetweenLegalHolidaysAndRegularHolidays')), 1),
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('ifYouSelectNotDistinguishAllWillBeLegalHolidays')), 1),
          _createVNode(_component_RadioGroup, {
            class: "mb-4",
            "options-radio": _ctx.distinguishingOption,
            modelValue: _ctx.workingStyleMasterParams.is_distinguishing_holiday_type,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.workingStyleMasterParams.is_distinguishing_holiday_type = $event)),
            errors: _ctx.errors.is_distinguishing_holiday_type,
            "onUpdate:errors": _cache[10] || (_cache[10] = ($event: any) => (_ctx.errors.is_distinguishing_holiday_type = $event)),
            onChange: _ctx.changeDistinguishingHolidayStatus
          }, null, 8, ["options-radio", "modelValue", "errors", "onChange"]),
          _createVNode("div", null, [
            _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('changeTheRegularHolidaysAcquiredWithinThe4thWeek')), 1),
            _createVNode(_component_RadioGroup, {
              "options-radio": _ctx.convertHolidayTypeList,
              modelValue: _ctx.workingStyleMasterParams.is_convert_holiday_type,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.workingStyleMasterParams.is_convert_holiday_type = $event)),
              disabled: 
              _ctx.workingStyleMasterParams.is_distinguishing_holiday_type !==
              _ctx.DISTINGUISHING_HOLIDAY_TYPE.DISTINGUISHING
            
            }, null, 8, ["options-radio", "modelValue", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.t('weeklyClosingDay')), 1),
          _createVNode(_component_Select, {
            "options-select": _ctx.dayOfWeekList,
            placeholder: _ctx.t('placeholderSelect'),
            "item-value": "key",
            "item-text": "value",
            errors: _ctx.errors.weekly_closing_day,
            "onUpdate:errors": _cache[12] || (_cache[12] = ($event: any) => (_ctx.errors.weekly_closing_day = $event)),
            modelValue: _ctx.workingStyleMasterParams.weekly_closing_day,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.workingStyleMasterParams.weekly_closing_day = $event))
          }, null, 8, ["options-select", "placeholder", "errors", "modelValue"])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, _toDisplayString(_ctx.t('lateNightWorkingTimeFrame')), 1),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode(_component_Select, {
                placeholder: _ctx.t('choice'),
                "options-select": _ctx.optionsChoseTime,
                "item-text": "text",
                modelValue: _ctx.workingStyleMasterParams.midnight_start_day_type,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.workingStyleMasterParams.midnight_start_day_type = $event)),
                errors: _ctx.errors.midnight_start_day_type,
                "onUpdate:errors": _cache[15] || (_cache[15] = ($event: any) => (_ctx.errors.midnight_start_day_type = $event)),
                validated: _ctx.validated,
                required: _ctx.isRequiredMidnightTime
              }, null, 8, ["placeholder", "options-select", "modelValue", "errors", "validated", "required"])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode(_component_InputTime, {
                modelValue: _ctx.workingStyleMasterParams.midnight_working_start,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.workingStyleMasterParams.midnight_working_start = $event)),
                errors: _ctx.errors.midnight_working_start,
                "onUpdate:errors": _cache[17] || (_cache[17] = ($event: any) => (_ctx.errors.midnight_working_start = $event)),
                validated: _ctx.validated,
                "error-server": _ctx.errorServer.midnight_working_start,
                required: _ctx.isRequiredMidnightTime
              }, null, 8, ["modelValue", "errors", "validated", "error-server", "required"])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_Select, {
                placeholder: _ctx.t('choice'),
                "options-select": _ctx.optionsChoseTime,
                "item-text": "text",
                modelValue: _ctx.workingStyleMasterParams.midnight_end_day_type,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.workingStyleMasterParams.midnight_end_day_type = $event)),
                errors: _ctx.errors.midnight_end_day_type,
                "onUpdate:errors": _cache[19] || (_cache[19] = ($event: any) => (_ctx.errors.midnight_end_day_type = $event)),
                validated: _ctx.validated,
                required: _ctx.isRequiredMidnightTime
              }, null, 8, ["placeholder", "options-select", "modelValue", "errors", "validated", "required"])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode(_component_InputTime, {
                modelValue: _ctx.workingStyleMasterParams.midnight_working_end,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.workingStyleMasterParams.midnight_working_end = $event)),
                errors: _ctx.errors.midnight_working_end,
                "onUpdate:errors": _cache[21] || (_cache[21] = ($event: any) => (_ctx.errors.midnight_working_end = $event)),
                validated: _ctx.validated,
                "error-server": _ctx.errorServer.midnight_working_end,
                required: _ctx.isRequiredMidnightTime
              }, null, 8, ["modelValue", "errors", "validated", "error-server", "required"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('distinguishingBetweenOfficeAndTelework')), 1),
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.distinguishingOptionCustom,
            modelValue: _ctx.workingStyleMasterParams.is_distinguishing_workplace,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.workingStyleMasterParams.is_distinguishing_workplace = $event)),
            errors: _ctx.errors.is_distinguishing_workplace,
            "onUpdate:errors": _cache[23] || (_cache[23] = ($event: any) => (_ctx.errors.is_distinguishing_workplace = $event))
          }, null, 8, ["options-radio", "modelValue", "errors"])
        ])
      ]),
      _createVNode("div", _hoisted_34, [
        _createVNode("div", _hoisted_35, _toDisplayString(_ctx.t('workingStyleSettings')), 1),
        _hoisted_36,
        _createVNode("div", null, [
          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.t('dutySystem')), 1)
        ]),
        _createVNode("div", _hoisted_38, [
          _createVNode(_component_Select, {
            class: "mr-4 w-2/5",
            "item-text": "label",
            "options-select": _ctx.workingTypeList,
            modelValue: _ctx.workingStyleMasterParams.working_type,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.workingStyleMasterParams.working_type = $event))
          }, null, 8, ["options-select", "modelValue"]),
          (
            _ctx.workingStyleMasterParams.working_type ===
            _ctx.WORKING_TYPE.STANDARD_LABOR
          )
            ? (_openBlock(), _createBlock(_component_Select, {
                key: 0,
                class: "w-2/5",
                "item-text": "label",
                "options-select": _ctx.wayOfWorkingList,
                modelValue: _ctx.workingStyleMasterParams.way_of_working,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.workingStyleMasterParams.way_of_working = $event))
              }, null, 8, ["options-select", "modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_BreakSetting, {
        modelValue: _ctx.workingStyleMasterParams,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.workingStyleMasterParams = $event)),
        validated: _ctx.validated,
        "error-server": _ctx.errorServer,
        "onUpdate:error-server": _cache[27] || (_cache[27] = ($event: any) => (_ctx.errorServer = $event)),
        errors: _ctx.errors,
        "onUpdate:errors": _cache[28] || (_cache[28] = ($event: any) => (_ctx.errors = $event))
      }, null, 8, ["modelValue", "validated", "error-server", "errors"]),
      _createVNode(_component_WorkingSchedule, {
        modelValue: _ctx.workingStyleMasterParams,
        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.workingStyleMasterParams = $event)),
        validated: _ctx.validated,
        errors: _ctx.errors,
        "onUpdate:errors": _cache[30] || (_cache[30] = ($event: any) => (_ctx.errors = $event))
      }, null, 8, ["modelValue", "validated", "errors"]),
      _createVNode(_component_GoOutSetting, {
        modelValue: _ctx.workingStyleMasterParams,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.workingStyleMasterParams = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AutomaticBreak, {
        modelValue: _ctx.workingStyleMasterParams,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.workingStyleMasterParams = $event)),
        validated: _ctx.validated,
        "error-server": _ctx.errorServer,
        "onUpdate:error-server": _cache[33] || (_cache[33] = ($event: any) => (_ctx.errorServer = $event)),
        errors: _ctx.errors,
        "onUpdate:errors": _cache[34] || (_cache[34] = ($event: any) => (_ctx.errors = $event))
      }, null, 8, ["modelValue", "validated", "error-server", "errors"]),
      _createVNode(_component_BeingLateTime, {
        modelValue: _ctx.workingStyleMasterParams,
        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.workingStyleMasterParams = $event)),
        validated: _ctx.validated,
        "error-server": _ctx.errorServer
      }, null, 8, ["modelValue", "validated", "error-server"]),
      _createVNode("div", _hoisted_39, [
        _createVNode(_component_Button, {
          class: "w-38 h-12 mr-4 font-size-16",
          variant: "outline-primary",
          onClick: _ctx.backToListWorkingStyleMaster
        }, {
          default: _withCtx(() => [
            _hoisted_40,
            _createTextVNode(" " + _toDisplayString(_ctx.t('buttonCancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "w-38 h-12",
          onClick: _ctx.openRegisterWorkingStyleMaster,
          disabled: _ctx.isDisableSubmit()
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_41, [
              _createTextVNode(_toDisplayString(_ctx.t('next')) + " ", 1),
              _hoisted_42
            ])
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ], 512), [
      [_vShow, !_ctx.isShowRegisterWorkingStyleMasterPopup]
    ]),
    _withDirectives(_createVNode(_component_ConfirmRegisterWorkingStyleMaster, {
      "error-server": _ctx.errorServer,
      workingStyleMasterParams: _ctx.workingStyleMasterParams,
      "onUpdate:workingStyleMasterParams": _cache[36] || (_cache[36] = ($event: any) => (_ctx.workingStyleMasterParams = $event)),
      validated: _ctx.validated,
      onOnClose: _ctx.closeRegisterWorkingStyleMaster,
      onOnSubmit: _ctx.submitCreateOrUpdateWorkingStyleMaster
    }, null, 8, ["error-server", "workingStyleMasterParams", "validated", "onOnClose", "onOnSubmit"]), [
      [_vShow, _ctx.isShowRegisterWorkingStyleMasterPopup]
    ])
  ], 64))
}